import React, { useEffect, useState } from "react";
import { useGeneralParams } from "../../../../hooks/useDataPaginate";
import {
  CreateSubCuentaValues,
  CreateValues,
  DeleteValues,
} from "../../../../FormSchemes/EfectivoGeneralScheme";
import { MinimalActionButton } from "../../../../components/form/minimalActionButton";
// import { CreateValuesExtraerSubEfectivosExterno } from '../../../../FormSchemes/EfectivoProductoScheme'
import { DefaultParamsForRecall } from "../../../../utils/defaulStates";
import { requestAuth } from "../../../../http/httpRequest";
import { toastOn } from "../../../../store/slices/toast";
import { 
  // useLocation, 
  useParams 
} from "react-router-dom";
// import { icon } from "leaflet";
export const ListEfectivoTable = ({
  globalParams,
  efectivoParams,
  reloaders,
  dispatchs,
}) => {
  const {
    dispatch,
    data,
    setData,
    paginate,
    setPaginate,
    selectedDay,
    setSelectedDay,
    selecteds,
    setSelecteds,
    selectAllChecked,
    setSelectAllChecked,
    isChecked,
    setIsChecked,
    stateData,
    setStateData,
    createModal,
    setCreateModal,
    deleteModal,
    setDeleteModal,
    currentData,
    setCurrentData,
    // imports
    requestAuthPaginate,
    TableContainer,
    Paginator,
    // formatFilters,
    Searcher,
    // FilterSelect,
    RangeDate,
    Actions,
    TableSection,
    ActionSection,
    Section,
    ModalForm,
    UpdateValuesModal,
    redirect,
    params,
  } = useGeneralParams();
  // const [extraerSubEfectivosModal, setExtraerSubEfectivosModal] = useState(false)
  const [CuentaPersonalModal, setCuentaPersonalModal] = useState(false);
  const [SubCuentaModal, setSubCuentaModal] = useState(false);
  const [SubCuentaProdModal, setSubCuentaProdModal] = useState(false);
  const [recalcularSubcajasModal, setRecalcularSubcajasModal] = useState(false);

  // let recallCount = 1

  const getDataPaginate = async () => {
    await requestAuthPaginate({
      method: "get",
      url:
        efectivoParams?.type === "subEfectivo"
          ? `/efectivo/${params.efectivo_id}/subEfectivos/pag`
          : `/efectivos/pag`,
      data: null,
      queries: paginate,
      setData: setData,
      setStateData: setStateData,
      setQueries: setPaginate,
      dispatch: dispatch,
      aditionalParams: { filterBy: "nombre", ...globalParams },
    });
  };
  useEffect(() => {
    getDataPaginate();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    ...DefaultParamsForRecall(paginate),
    paginate.estado,
    params.efectivo_id,
    ...reloaders,
  ]);

  useEffect(() => {
    setSelectAllChecked(false);
    setIsChecked(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...DefaultParamsForRecall(paginate), paginate.estado]);

  const recall = () => {
    dispatchs();
  };

  const parseMonto = (v) => {
    if (v === null || v === undefined) return 0;
    if (typeof v === "number") return v;

    const s = String(v).trim();
    if (s === "") return 0;

    const hasComma = s.includes(",");
    const hasDot = s.includes(".");

    let t = s;

    if (hasComma && hasDot) {
      t = s.replace(/\./g, "").replace(/,/g, ".");
    } else if (hasComma) {
      if (/^\d{1,3}(,\d{3})+(\.\d+)?$/.test(s)) {
        t = s.replace(/,/g, "");
      } else {
        t = s.replace(/,/g, ".");
      }
    } else if (hasDot) {
      if (/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(s)) {
        t = s.replace(/\./g, "");
      }
    }

    const n = Number(t);
    return Number.isNaN(n) ? 0 : n;
  };


  // const parseMoney = (strOrNum) => {
  //   if (strOrNum === null || strOrNum === undefined) return 0;
  //   if (typeof strOrNum === 'number') return strOrNum;
  //   const s = String(strOrNum).trim();
  //   // quita miles '.' y cambia ',' por '.'
  //   return parseFloat(s.replace(/\./g, "").replace(",", ".")) || 0;
  // };

  const enviarTraspaso = async (origenId, destino, monto, label) => {
    const monedas = parseMonto(destino.monedas_total);
    const billetes = parseMonto(destino.billetes_total);
    const payload = {
      dataList: [
        {
          efectivo_id: origenId,
          // efectivo_id: destino.id,
          monto_total: parseMonto(monto),
          billetes,
          monedas,
        },
      ],
      efectivo_id: destino.id,
      // efectivo_id: origenId,
      transaccion_estado_nombre: "Traspaso directo",
    };

    try {
      await requestAuth("post", "/efectivoTraspasos?context=express", payload);
      getDataPaginate();
      dispatch(toastOn({ type: "success", message: `Éxito ${label}` }));
    } catch (error) {
      dispatch(
        toastOn({
          type: "danger",
          message:
            error?.response?.data?.message ??
            `Error al enviar el formulario (${label})!`,
        })
      );
    }
  };

  // const location = useLocation();
  const paramsRoute = useParams();

  const buscarProductos = async () => {
    let key = "";

    switch (paramsRoute.menuname) {
      case "caja-central":
        key = "CAJA";
        break;
      case "bancos-central":
        key = "BANCOS";
        break;
      case "garantías-en-efectivo-central":
        key = "GARANTÍAS EN EFECTIVO";
        break;
      case "garantías-en-bancos-central":
        key = "GARANTÍAS EN BANCOS";
        break;
      default:
        key = "";
        break;
    }
    if (!data?.data) return;

    const productos = data.data;

    const caja = productos.find(
      (p) => p.producto_id === null && p.nombre === key
    );
    const ac200 = productos.find(
      (p) => p.producto_id && p.producto_nombre === "AC - 200LT"
    );
    const ac100 = productos.find(
      (p) => p.producto_id && p.producto_nombre === "AC - 100LT"
    );

    if (!caja) {
      dispatch(toastOn({ type: "danger", message: "No se encontró CAJA" }));
      return;
    }

    console.log(ac200);

    const monto200 = parseMonto(ac200?.monto_total);
    const monto100 = parseMonto(ac100?.monto_total);

    if (monto200 > 0) await enviarTraspaso(caja.id, ac200, monto200, "200LT");
    if (monto100 > 0) await enviarTraspaso(caja.id, ac100, monto100, "100LT");
  };

  return (
    <Section>
      <ActionSection>
        {globalParams?.tipo === "otras-cuentas" &&
        efectivoParams?.type !== "subEfectivo" ? (
          <Actions
            buttons={[
              {
                icon: "add",
                label: "Crear cuenta general",
                action: () => setCreateModal(true),
              },
              {
                icon: "add",
                label: "Crear cuenta personal",
                action: () => setCuentaPersonalModal(true),
                className: "dark:bg-red-700 bg-red-500 text-white",
              },
            ]}
          />
        ) : (
          efectivoParams?.type === "subEfectivo" && (
            <Actions
              buttons={[
                {
                  icon: "add",
                  label: "Crear sub-cuenta",
                  action: () => setSubCuentaModal(true),
                  className: "dark:bg-cyan-700 bg-cyan-500 text-white",
                },
                {
                  icon: "add",
                  label: "Crear sub-cuenta de producto",
                  action: () => setSubCuentaProdModal(true),
                  className: "dark:bg-rose-700 bg-rose-500 text-white",
                },
                {
                  icon: "add",
                  label: "Traspaso Express",
                  action: () => buscarProductos(),
                  className: "dark:bg-yellow-700 bg-yellow-500 text-white",
                },
                {
                  icon: "repeat",
                  label: "Recalcular sub-cajas",
                  action: () => {
                    setCurrentData({ id: params.efectivo_id })
                    setRecalcularSubcajasModal(true)
                  },
                  className: "dark:bg-indigo-700 bg-indigo-500 text-white",
                }
              ]}
            />
          )
        )}
        {/* {
                    efectivoParams?.type === 'subEfectivo' &&
                    <Actions
                        buttons={[
                            {
                                icon: 'minus',
                                label: 'Centralizar efectivo',
                                action: () => setExtraerSubEfectivosModal(true),
                                className: 'dark:bg-red-700 bg-red-500 text-white'
                            },
                        ]}
                    />
                } */}
        <Searcher
          paginate={paginate}
          setPaginate={setPaginate}
          selectedDay={selectedDay}
          setSelectedDay={setSelectedDay}
          options={[
            {
              label: "Nombre",
              value: "nombre",
            },
            // {
            //   label: "Producto",
            //   value: "producto_nombre",
            // },
          ]}
        />
        <div className="flex gap-2 flex-wrap">
          <RangeDate
            selectedDay={selectedDay}
            setSelectedDay={setSelectedDay}
            paginate={paginate}
            setPaginate={setPaginate}
          />
          {/* <FilterSelect
            paginate={paginate}
            setPaginate={setPaginate}
            formatFilter={formatFilters}
            name="estado"
            options={[
              {
                label: "Estado",
                value: "",
              },
              {
                label: "Activo",
                value: "activo",
              },
              {
                label: "Inactivo",
                value: "inactivo",
              },
            ]}
          /> */}
          <MinimalActionButton icon="repeat" label="" action={recall} />
        </div>
      </ActionSection>
      <TableSection stateData={stateData} paginator={Paginator} data={data}>
        <TableContainer
          headers={[
            efectivoParams?.type === "subEfectivo"
              ? null
              : {
                  label: "Entidad",
                  columns: [
                    "nro",
                    "nombre",
                    "encargado_nombre",
                    "encargado_detalles",
                  ],
                },
            efectivoParams?.type === "subEfectivo"
              ? {
                  label: "Cuenta",
                  columns: [
                    "nro",
                    "nombre",
                    "encargado_nombre",
                    "encargado_detalles",
                    "producto_nombre",
                  ],
                }
              : null,
            // {
            //     label: 'Encargado',
            //     columns: ['encargado_nombre', 'encargado_detalles']
            // },
            {
              label: "Monto total Bs.",
              columns: ["monto_total"],
              numberValue: true,
              sumDec: true,
            },
            {
              label: "Monto ingreso Bs.",
              columns: ["monto_total_ingreso"],
              numberValue: true,
              sumDec: true,
            },
            {
              label: "Monto egreso Bs.",
              columns: ["monto_total_egreso"],
              numberValue: true,
              sumDec: true,
            },
            {
              label: "Billetes Bs.",
              columns: ["billetes_total"],
              numberValue: true,
              sumDec: true,
            },
            {
              label: "Monedas Bs.",
              columns: ["monedas_total"],
              numberValue: true,
              sumDec: true,
            },
            {
              label: "Dolares Sus.",
              columns: ["dolares_total"],
              numberValue: true,
              sumDec: true,
            },
            {
              label: "Dolares Bs.",
              columns: ["dolares_en_bs_total"],
              numberValue: true,
              sumDec: true,
            },
            {
              label: "Acciones",
              actions: [
                efectivoParams?.type === "subEfectivo"
                  ? null
                  : {
                      type: "yellow",
                      icon: "fa-table",
                      action: (data) => {
                        redirect(`${data.id}`);
                      },
                      reference: "id",
                      tooltipText: "Sub-cuentas",
                      redirect: true,
                      newIcon: {
                        className: "material-symbols-outlined",
                        name: "apps",
                      },
                    },
                {
                  type: "cyan",
                  icon: "fa-plus-minus",
                  action: (data) => redirect(`historial/${data.id}`),
                  reference: "id",
                  tooltipText: "Ingreso/Egresos",
                  redirect: true,
                  newIcon: {
                    className: "material-symbols-outlined",
                    name: "exposure",
                  },
                },
                {
                  type: "green",
                  icon: "fa-money-bills",
                  action: (data) => redirect(`cierres/${data.id}`),
                  reference: "id",
                  tooltipText: "Cierres",
                  redirect: true,
                  newIcon: {
                    className: "material-symbols-outlined",
                    name: "universal_currency_alt",
                  },
                },
                {
                  type: "delete",
                  icon: "fa-trash",
                  action: (data) =>
                    UpdateValuesModal(data, setCurrentData, setDeleteModal),
                  reference: "id",
                  tooltipText: "Eliminar",
                  validate: { value: "abierto", validator: true },
                },
              ],
              // stickyR: true
            },
          ]}
          data={data?.data}
          doubleClickAction={
            efectivoParams?.type === "subEfectivo"
              ? (dataItem) => redirect(`historial/${dataItem.id}`)
              : (dataItem) => redirect(`${dataItem.id}`)
          }
          checkList={false}
          selecteds={selecteds}
          setSelecteds={setSelecteds}
          selectAllChecked={selectAllChecked}
          setSelectAllChecked={setSelectAllChecked}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
          stateData={stateData}
        />
      </TableSection>
      {createModal && (
        <ModalForm
          setModal={setCreateModal}
          label={`Crear cuenta general`}
          dataValues={CreateValues(false)}
          urlApi={"/efectivo"}
          method={"post"}
          call={recall}
          buttonLabel="Registrar"
        />
      )}
      {CuentaPersonalModal && (
        <ModalForm
          setModal={setCuentaPersonalModal}
          label="Crear cuenta personal"
          dataValues={CreateValues(true)}
          urlApi={"/efectivo"}
          method={"post"}
          call={recall}
          buttonLabel="Registrar"
        />
      )}
      {SubCuentaModal && (
        <ModalForm
          setModal={setSubCuentaModal}
          label="Crear sub-cuenta"
          dataValues={CreateSubCuentaValues(params.efectivo_id)}
          urlApi={"/efectivo"}
          method={"post"}
          call={recall}
          buttonLabel="Registrar"
        />
      )}
      {SubCuentaProdModal && (
        <ModalForm
          setModal={setSubCuentaProdModal}
          label="Crear sub-cuenta de producto"
          dataValues={CreateSubCuentaValues(params.efectivo_id, true)}
          urlApi={"/efectivo"}
          method={"post"}
          call={recall}
          buttonLabel="Registrar"
        />
      )}
      {deleteModal && (
        <ModalForm
          setModal={setDeleteModal}
          label="Eliminar efectivo"
          dataValues={DeleteValues(currentData)}
          urlApi={`/efectivo/${currentData.id}`}
          method={"delete"}
          call={recall}
          buttonLabel="Eliminar"
        />
      )}
      {recalcularSubcajasModal && currentData?.id && (
        <ModalForm
          setModal={setRecalcularSubcajasModal}
          label="Recalcular sub-cajas"
          dataValues={DeleteValues(currentData)}
          urlApi={`/efectivo/${currentData.id}/recalcular?recalcularSubcajas=true`}
          method={"post"}
          call={() => {
              recall()
              getDataPaginate()
            }
          }
          buttonLabel="Recalcular"
        />
       )
      }
      {/* {
                extraerSubEfectivosModal &&
                <ModalForm
                    setModal={setExtraerSubEfectivosModal}
                    label='Cargar almacenes'
                    dataValues={CreateValuesExtraerSubEfectivosExterno(dataCard)}
                    urlApi={`/extraerSubEfectivos`}
                    method={'post'}
                    call={() => {
                        recall()
                        // dispatch(setReloadSubTable())
                        // dispatch(setReloadMainTable())
                    }}
                    buttonLabel='Registrar'
                />
            } */}
    </Section>
  );
};
